export default __webpack_public_path__ + "static/media/vga.e9b42c46.gif";